import * as React from 'react'

import { LOCIZE_NAMESPACE } from 'main/common'
import { Button, spacing, Title } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { i18nKeyPrefix } from '../../../i18n'
import { ScheduleTourModal_school } from '../../common/gql'
import SchoolSummary from '../../common/SchoolSummary'

const PRE = `${i18nKeyPrefix}-SCHEDULE-MODAL-NOT-TOURING`

interface IProps {
  school: ScheduleTourModal_school
  onComplete: () => void
  onRequestClose: () => void
}

export default function NotTouring(props: IProps) {
  const { school, onComplete } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <div>
      <div css={{ marginTop: spacing.majorScale(2) }}>
        <SchoolSummary school={school} />
      </div>
      <Title kind="section" css={{ marginTop: spacing.majorScale(2), textAlign: 'center' }}>
        {t(`${PRE}-TITLE`)}
      </Title>
      <div
        css={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: spacing.majorScale(4),
          marginTop: spacing.majorScale(5),
        }}
      >
        <Button onClick={() => onComplete()}>{t(`${PRE}-BUTTON`)}</Button>
      </div>
    </div>
  )
}
